// src/utils/storageUrlCache.js
//
// Firebase Storage download URLs are stable per file, so re-resolving them
// via getDownloadURL() on every page load is wasted work. This caches
// resolved URLs in memory and localStorage (keyed by storage path) so
// repeat visits, even across browser sessions, skip the network round trip.

import { ref, getDownloadURL } from "firebase/storage";

const memoryCache = new Map();
const STORAGE_KEY_PREFIX = "storageUrl:";

export async function getCachedDownloadURL(storage, path) {
  if (memoryCache.has(path)) {
    return memoryCache.get(path);
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY_PREFIX + path);
    if (stored) {
      memoryCache.set(path, stored);
      return stored;
    }
  } catch (error) {
    // localStorage may be unavailable (e.g. private browsing); fall through to a live fetch.
  }

  const url = await getDownloadURL(ref(storage, path));
  memoryCache.set(path, url);
  try {
    localStorage.setItem(STORAGE_KEY_PREFIX + path, url);
  } catch (error) {
    // Ignore quota/availability errors; the in-memory cache still works for this session.
  }
  return url;
}
